import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import store, { history } from "./store";
import AppContainer from "./views/app";
import { unregister } from "./registerServiceWorker";
import { LocalizeProvider } from "react-localize-redux";
import { ConfigProvider } from "antd";
import enUS from "antd/lib/locale-provider/en_GB";
import moment from "moment";
import numeral from "numeral";
import "moment/locale/en-gb";
import "./index.less";
import { ConnectedRouter } from "connected-react-router/immutable";
import { datadogRum } from "@datadog/browser-rum";
import { getConfig } from './common/config';

const defaultLanguage = "id";

datadogRum.init({
  applicationId: getConfig('DD_APP_ID', process.env.REACT_APP_DD_APP_ID),
  clientToken: getConfig('DD_CLIENT_TOKEN', process.env.REACT_APP_DD_CLIENT_TOKEN),
  sampleRate: 100,
  trackInteractions: true,
  version: getConfig('VERSION', process.env.REACT_APP_VERSION),
  env: process.env.NODE_ENV,
});

moment.locale("id");
numeral.register("locale", "id", {
  delimiters: {
    thousands: ".",
    decimal: ",",
  },
  abbreviations: {
    thousand: "rb",
    million: "jt",
    billion: "m",
    trillion: "t",
  },
  currency: {
    symbol: "RP",
  },
});
numeral.locale(defaultLanguage);

render(
  <Provider store={store}>
    <LocalizeProvider store={store}>
      <ConfigProvider locale={enUS}>
        <ConnectedRouter history={history}>
          <AppContainer />
        </ConnectedRouter>
      </ConfigProvider>
    </LocalizeProvider>
  </Provider>,
  document.querySelector("#root")
);

// unregistered SW.
unregister();
